import { ajax } from '@/api/ajax';
import { hostNameToEnvMap, Env } from '@/models/global';

/** 通用文件下载接口的入参 —— 三选一即可，优先级：fileId > (bucketName + objectKey) > fileUrl */
export interface FilePreviewReq {
  /** base 服务的文件唯一 ID（首选） */
  fileId?: string;
  /** OSS 对象键（配合 bucketName 使用） */
  objectKey?: string;
  /** OSS bucket 名（配合 objectKey 使用） */
  bucketName?: string;
  /** 含 aliyuncs.com/ 的完整 OSS URL（兼容旧路径） */
  fileUrl?: string;
  /** 签名 URL 有效期（秒，缺省服务端默认） */
  validDuration?: number;
  isPreview?: boolean | null;
}

/** 通用文件下载接口的返回体 */
export interface FilePreviewResp {
  fileId: string;
  fileName: string;
  fileUrl: string;
  bucketName: string;
  objectKey: string;
  /** OSS 签名 URL，可直接 window.open */
  downloadUrl: string;
  fileSize: number;
}

/**
 * 判断当前是否为国际域名（sip-eu.uat.xpeng.com / tis.xpeng.com）。
 * 未匹配的 hostname（如 localhost 本地开发）默认按国内处理。
 */
function isGlobalEnv(): boolean {
  const env = hostNameToEnvMap[window.location.hostname];
  return env === Env.globalDeployTest || env === Env.globalProd;
}

/**
 * 附件下载接口
 *
 * 国内 / 国际使用同一份代码，但走不同的网关路径：
 *   - **国内**（`sip.test` / `sip.deploy-test` / `sip.xiaopeng.com`）：
 *       走 tis 网关透传 → `/api/tis/web/sip/notice/file/download`
 *       后端和 `listSecondChannels` 在同一个 Controller，由 tis 层透传到 base 服务
 *       （国内网关 `xdragon-node-gateway-c` 未开放直接调 base 的 `/base/*` 路由）
 *   - **国际**（`sip-eu.uat` / `tis.xpeng.com`）：
 *       走 base 通用下载接口 → `/api/base/v1/file/operate/download`
 *       网关直接转发到 `xp-dragon-base-service-eu-boot`
 *
 * 请求参数与返回体结构一致（tis 层原样透传 base 服务的 body），
 * 调用方通过 `res.data.downloadUrl` 拿到 OSS 签名 URL 后 `window.open` 即可。
 */
export function getPreviewFile(params: FilePreviewReq) {
  const url = isGlobalEnv()
    ? '/api/base/v1/file/operate/download'
    : '/api/tis/web/sip/notice/file/download';
  return ajax<FilePreviewResp>({
    url,
    method: 'post',
    data: params
  });
}
